import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBView } from "mdbreact";
import { Search } from "../../../../../components/searchables";
import {
  BROWSE,
  SetCREATE,
  SetFILTER,
} from "../../../../../services/redux/slices/market/machines";
import { buildMachineDataset, modeMeta } from "./utils";

const supplierModes = ["registry", "stock", "tieup"];

export default function MachineHeader({ mode }) {
  const dispatch = useDispatch();
  const { token, activePlatform } = useSelector(({ auth }) => auth);
  const { collections = [] } = useSelector(({ machines }) => machines);
  const meta = modeMeta[mode] || modeMeta.registry;
  const branchId = activePlatform?.branchId;
  const dataset = useMemo(
    () => buildMachineDataset(collections, mode),
    [collections, mode]
  );

  useEffect(() => {
    if (token && branchId && collections.length === 0) {
      dispatch(
        BROWSE({
          token,
          params: supplierModes.includes(mode)
            ? { supplierId: branchId }
            : { branchId },
        })
      );
    }
  }, [branchId, collections.length, dispatch, mode, token]);

  useEffect(() => {
    dispatch(SetFILTER(dataset));
  }, [dataset, dispatch]);

  return (
    <MDBView
      cascade
      className="gradient-card-header blue-gradient narrower py-2 mx-4 mb-3 d-flex justify-content-between align-items-center"
    >
      <div className="d-flex flex-column px-2">
        <span className="white-text font-weight-bold">{meta.title}</span>
        <small className="white-text">
          {dataset.length} supplier-owned fixed assets
        </small>
      </div>
      <Search
        collections={dataset}
        setFiltered={(items) => dispatch(SetFILTER(items))}
        reset={() => dispatch(SetFILTER(dataset))}
        placeholder={meta.searchPlaceholder}
        hideButton={false}
        haveAction={
          mode === "registry" || mode === "stock" || mode === "tieup"
        }
        handleAdd={() => dispatch(SetCREATE())}
      />
    </MDBView>
  );
}
